import { Helmet } from 'react-helmet';
const DeleteAccount = () => {
    return (
        <>
            <Helmet>
                <title>Delete Account</title>
            </Helmet>
            {/* start: delete-account page */}
            <div className="min-h-screen gradient-bg-1 p-6">
                <div className="flex items-center gap-4 mb-8">
                    <button className="text-foreground/70 hover:text-foreground transition-colors">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-xl font-bold text-foreground">Delete Account</h1>
                </div>
                <div className="max-w-md mx-auto" style={{ opacity: 1, transform: "none" }}>
                    <div
                        className="bg-destructive/10 rounded-2xl p-6 border-2 border-destructive/30 mb-6"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <div className="flex items-center gap-3 mb-4">
                            <div className="bg-destructive/20 rounded-full p-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="red"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-triangle-alert w-6 h-6 text-destructive"
                                >
                                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                            </div>
                            <div>
                                <h2 className="font-bold text-foreground">
                                    This action is permanent
                                </h2>
                                <p className="text-sm text-muted-foreground">
                                    Your data cannot be recovered
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <h3 className="font-semibold text-foreground mb-4">
                            What will be permanently deleted:
                        </h3>
                        <div className="space-y-3">
                            <div
                                className="flex items-center gap-3 text-foreground/80"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <div className="bg-secondary rounded-full p-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-message-circle w-4 h-4 text-muted-foreground"
                                    >
                                        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                                    </svg>
                                </div>
                                <span className="text-sm">All chat history with Reya</span>
                            </div>
                            <div
                                className="flex items-center gap-3 text-foreground/80"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <div className="bg-secondary rounded-full p-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-phone w-4 h-4 text-muted-foreground"
                                    >
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                    </svg>
                                </div>
                                <span className="text-sm">Voice &amp; video call records</span>
                            </div>
                            <div
                                className="flex items-center gap-3 text-foreground/80"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <div className="bg-secondary rounded-full p-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-heart w-4 h-4 text-muted-foreground"
                                    >
                                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                    </svg>
                                </div>
                                <span className="text-sm">Saved preferences &amp; memories</span>
                            </div>
                        </div>
                    </div>
                    <div
                        className="bg-card rounded-2xl p-4 border border-border mb-8"
                        style={{ opacity: 1 }}
                    >
                        <p className="text-sm text-foreground/80 text-center">
                            <span className="font-medium">Your privacy matters.</span> Once deleted,
                            your information is removed from our servers within 30 days.
                        </p>
                    </div>
                    <div className="space-y-3">
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full">
                            Keep My Account
                        </button>
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border bg-background hover:text-accent-foreground h-10 px-4 py-2 w-full border-destructive/50 text-destructive hover:bg-destructive/10">
                            Continue to Delete
                        </button>
                    </div>
                </div>
            </div>
            {/* end: delete-account page */}
        </>
    );
}

export default DeleteAccount;
